(function (window, document, undefined) {
  "use strict";

  let Vue = window.Vue || false,
    logger;

  /**
   * Show the interaction bar.
   *
   * @return {void}
   */
  const showInteractionBar = () => {
    const interactionBar = document.querySelector(
      ".vodl-region-article__interaction-bar"
    );

    if (interactionBar) {
      interactionBar.removeAttribute("hidden");
    }

    document.dispatchEvent(new Event("vodl_show_interaction_bar"));
  };

  /**
   * Show the interaction bar.
   *
   * @return {void}
   */
  const showBottomInteractionBar = () => {
    const interactionBar = document.querySelector(
      ".vodl-region-article__bottom-interaction"
    );

    if (interactionBar) {
      interactionBar.removeAttribute("hidden");
    }
  };

  /**
   * Grab the JSON that should be provided in the page and parse it.
   *
   * @param {HTMLElement} wrapper The wrapper element containing the JSON data.
   * @return {object|boolean} The interaction bar data object on success, false otherwise.
   */
  const parseDataNode = function (wrapper) {
    const dataNode = wrapper.querySelector('script[type="application/json"]');

    let parsedDataNode = {};

    try {
      parsedDataNode = JSON.parse(dataNode.innerHTML) || false;
    } catch (e) {
      return false;
    }

    return parsedDataNode;
  };

  const renderComponent = (config) => {
    const classExtension = config.classExtension ?? "";

    const interactionBar = Vue.createApp({
      components: {
        InteractionBar: window["@russmedia-frontend/common"].InteractionBar,
        SocialBookmarksModal:
          window["@russmedia-frontend/np-common"].SocialBookmarksModal,
      },
      setup() {
        const post = Vue.ref(config.post ?? {});
        const interactionStats = Vue.ref(config.stats ?? []);
        const showSocials = Vue.ref(false);
        const isNativeArticle = Vue.ref(config.isNative ?? false);

        const ttsData = Vue.ref({
          source: config.audio?.source ?? "",
          postId: config.audio?.post_id ?? false,
          autoplay: config.audio?.autoplay ?? false,
        });

        /**
         * Audio-player: fetch audio data via nnp rest API.
         * If successful set source for vue instance and start playing.
         *
         * @param {int} post_id   NNP post ID of current post.
         */
        function fetchAudioData(post_id) {
          let service_url = "wp-json/tts/v1/speech_service";
          let url =
            window.location.protocol +
            "//" +
            window.location.hostname +
            "/" +
            service_url;

          console.log("[tts]: fetchAudioData()", "post_id: " + post_id);

          fetch(url + "?p=" + post_id)
            .then(function (response) {
              // The API call was successful!
              return response.json();
            })
            .then(function (data) {
              if (data.file) {
                logger.log("[tts]: fetchAudioData()", "file: " + data.file);

                ttsData.value.source = data.file;
                ttsData.value.autoplay = true;
              } else {
                console.warn("[tts]:" + data.code, data.message);
              }
            })
            .catch(function (err) {
              // There was an error.
              console.warn("[tts]: " + err);
            });
        }

        function onInteraction(interaction) {
          if (interaction.type === "share" && !isNativeArticle.value) {
            showSocials.value = true;
          }

          if (interaction.type === "home") {
            if (window.history.length > 1) {
              history.back();
            } else {
              window.location.href = "/";
            }
          }

          document.dispatchEvent(
            new CustomEvent("vodl_interaction_clicked", {
              detail: {
                interaction,
              },
            })
          );
        }

        function onSocialClose() {
          showSocials.value = false;
        }

        Vue.onMounted(() => {
          document.addEventListener("vodl_show_full_content", function () {
            interactionStats.value = interactionStats.value.map(
              (interaction) => {
                if (interaction.type === "text-to-speech") {
                  interaction.disabled = false;
                }

                return interaction;
              }
            );
          });
        });

        return {
          interactionStats,
          ttsData,
          fetchAudioData,
          onInteraction,
          onSocialClose,
          showSocials,
          post,
        };
      },
      template: `<InteractionBar :stats="interactionStats" @interaction-clicked="onInteraction" :audio="ttsData" @fetch-data="fetchAudioData" />
        <SocialBookmarksModal v-if="showSocials" :url="post.link" :text="post.title" @close="onSocialClose" @button-clicked="onSocialClose" />
      `,
    }).mount(`#vodl-interaction-bar__wrapper${classExtension}`);
  };

  /**
   * Initializes the interaction bar functionality.
   *
   */
  const init = () => {
    try {
      logger = new window.RussMedia.Utils.Logger("[interaction bar]") || {
        log: function () {},
      };
    } catch (e) {
      logger = { log: function () {} };
    }

    if (!Vue) {
      logger.log("_init: No Vue!");
      return;
    } else {
      logger.log("Load Vue component.");
    }

    document.querySelectorAll(".vodl-interaction-bar").forEach((element) => {
      let interactionBarData = parseDataNode(element);

      if (!interactionBarData) {
        logger.log("interaction bar _init: No interaction bar data.");
        return;
      }

      renderComponent(interactionBarData);
    });
  };

  init();

  window.RussMedia = window.RussMedia || {};
  window.RussMedia.InteractionBar = window.RussMedia.InteractionBar || {};

  Object.assign(window.RussMedia.InteractionBar, {
    showInteractionBar: showInteractionBar,
    showBottomInteractionBar: showBottomInteractionBar,
  });
})(window, document);
